module.exports = __webpack_public_path__ + "static/media/card-bg1@2x.47d24744.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_42/imgs/card-bg1@2x.png
// module id = 994
// module chunks = 0